import api from "@/api/apiConfig"
import {
  Post,Get
} from './base/baseAjax'
let getApproval = (param) => {
  return Post({
    url: api.reimburse.getApproval,
    bodyParam: param
  })
}
let getApprovalDetails = (param) => {
  return Get({
    url: api.reimburse.getApprovalDetails,
    PathParam: param
  })
}
let confirmPayment = (param) => {
  return Get({
    url: api.reimburse.confirmPayment,
    PathParam: param
  })
}
let downloadpdf = (param) => {
  return Get({
    url: api.reimburse.downloadpdf,
    PathParam: param
  })
}

export default {
  getApproval,
  getApprovalDetails,
  downloadpdf,
  confirmPayment
}



// WEBPACK FOOTER //
// ./src/services/reimburse.js